import { Component, contentChild, input, TemplateRef, viewChild } from '@angular/core';


@Component({
  selector: 'soft-page-tab',
  imports: [],
  templateUrl: './page-tab.component.html',
  styleUrl: './page-tab.component.css',
})
export class PageTabComponent {
  name = input<string>();
  title = input<string>();
  class = input<string>();
  icon = input<string>();
  template = viewChild(TemplateRef);
  contentTemplate = contentChild(TemplateRef);
}
